import { Component, inject, output } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { filter, map } from 'rxjs';

import { isNil } from '@core/utils/shared-utils';

@Component({
  selector: 'app-new-params',
  templateUrl: './new-params.html',
  styles: ``,
  imports: [TranslatePipe, ReactiveFormsModule]
})
export class NewParams {
  private readonly translate = inject(TranslateService);
  private fb = inject(FormBuilder);

  closeModal = output();
  newSolverOutput = output<{ name: string; description: string }>();

  protected currentLang = toSignal(
    this.translate.onLangChange.pipe(
      filter((value) => !isNil(value)),
      map((value) => value.lang)
    ),
    { initialValue: this.translate.getCurrentLang() }
  );

  form = this.fb.group({
    name: ['', [Validators.required, Validators.minLength(2)]],
    description: ['']
  });

  onSubmit() {
    if (this.form.valid) {
      const name = this.form.get('name')?.value || '';
      const description = this.form.get('description')?.value || '';
      this.newSolverOutput.emit({ name, description });
      this.closeModal.emit();
    } else {
      this.form.markAllAsTouched();
    }
  }

  protected onCancel() {
    this.closeModal.emit();
  }

  private readonly translationPrefixKey = 'common.';
  protected readonly cancelKey = this.translationPrefixKey + 'cancel';
  protected readonly submitKey = this.translationPrefixKey + 'submit';
  protected readonly nameKey = this.translationPrefixKey + 'name';
  protected readonly descriptionKey = this.translationPrefixKey + 'description';
}
